import { postDashboardFormStatusDownstream } from '../../shared/utilities/apiClient';

export const sendFormStatusDownstream = (
    formId: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    postDashboardFormStatusDownstream(formId, {
        headers: {
            'Toast-Pending-Text': toastText?.onPendingText,
            'Toast-Success-Text': toastText?.onSuccessText,
        },
    })
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
